import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Modal } from 'react-bootstrap';
import styles from './style.css';

class ConfirmModal extends React.Component {
  render() {
    const {
      onHide,
      onCancel,
      showModal,
      disableHideOnOuterModal,
      title,
      description,
      onConfirm,
      confirmTitle,
      cancelTitle,
      hideCancelButton,
      confirmClassName,
      dialogClassName,
      baseColor,
      confirmDisabled,
      backdrop,
    } = this.props;

    return (
      <Modal
        backdrop={backdrop}
        onHide={
          disableHideOnOuterModal
            ? function() {
                /* no op */
              }
            : onHide
        }
        show={showModal}
        dialogClassName={classNames(
          styles.dialog,
          'modal-dialog',
          dialogClassName
        )}
        data-testid="modal"
      >
        <Modal.Header
          className={`${baseColor === 'danger' ? styles.danger : ''}`}
        >
          <button
            onClick={onHide}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            data-testid="btn-hide"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <Modal.Title className={styles['title-modal']} data-testid="title">
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>{description}</div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            {!hideCancelButton && (
              <button
                type="button"
                className="btn btn-default"
                onClick={onCancel || onHide}
                data-testid="btn-cancel"
              >
                {cancelTitle || 'Cancel'}
              </button>
            )}
            <button
              type="button"
              className={`btn btn-primary ${confirmClassName} ${
                baseColor === 'danger' ? styles.danger : ''
              }`}
              onClick={onConfirm}
              data-testid="btn-confirm"
              disabled={confirmDisabled}
            >
              {confirmTitle || 'OK'}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

ConfirmModal.propTypes = {
  onHide: PropTypes.func,
  disableHideOnOuterModal: PropTypes.bool,
  showModal: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.node,
  // if this is null, the 'cancel' will use onHide instead
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  backdrop: PropTypes.oneOf(['static', true, false]),
};

ConfirmModal.defaultProps = {
  onCancel: null,
};

export default ConfirmModal;
